// eslint-disable-next-line import/prefer-default-export
export function openContent(action) {
    if (action.linkTarget === 'POP_UP') {
        // TODO: Rewrite without Liferay util.
        window.Liferay.Util.openWindow({
            dialog: { destroyOnHide: true },
            dialogIframe: { bodyCssClass: 'dialog-with-footer' },
            title: action.title,
            uri: action.url,
        });
    }
    else {
        const url = action.url.replace('redirectPlaceholder', encodeURIComponent(window.location.toString()));
        window.open(url, action.linkTarget === 'BLANK' ? '_blank' : '_self');
    }
}
